import CopyButton from '@/src/components/AppComponents/CopyButton/CopyButton';
import { DetailsBalance } from '@/src/components/AppComponents/ModalUTxOs/DetailsBalance/DetailsBalance';
import { DetailsUTxOs } from '@/src/components/AppComponents/ModalUTxOs/DetailsUTxO/DetailsUTxO';
import OpenInNewTabButton from '@/src/components/AppComponents/OpenInNewTabButton/OpenInNewTabButton';
import { Button } from '@/src/components/Commons/Button';
import LoaderButton from '@/src/components/Commons/LoaderButton/LoaderButton';
import { formatAddress } from '@/src/lib/SmartDB/Commons/formatters';
import { CLOSE } from "@/src/lib/SmartDB/Commons/Constants/images";
import { UTxO } from '@lucid-evolution/lucid';
import styles from './ModalUTxOs.module.scss';
import { useModalUTxOsAndBalance } from './useModalUTxOs';

export const ModalUTxOsAndBalance = ({ address, uTxOs, showBalance = false }: { address: string; uTxOs?: UTxO[]; showBalance?: boolean }) => {
    //--------------------------------------
    const { appStore, isRefreshing, isLoadingList, list, showBalance_, isOpen, handleOpen, handleClose, setShowBalance } = useModalUTxOsAndBalance({
        address,
        uTxOs,
        showBalance,
    });
    //--------------------------------------
    return (
        <>
            <Button mode="outline-no-arrow" size="small" width={100} onClick={handleOpen}>
                View {showBalance ? 'Balance' : list.length <= 1 ? 'UTxO' : 'UTxOs'}
            </Button>
            {isOpen ? (
                <div className={styles.modal}>
                    <div className={`${styles.main}`}>
                        <div className={styles.popUp}>
                            <header className={styles.headerModal}>
                                <h2 className={styles.titleModal}>{showBalance_ ? 'Balance' : list.length <= 1 ? 'UTxO' : 'UTxOs'}</h2>
                                <div className={styles.buttonsModal}>
                                    <Button
                                        mode="outline-no-arrow"
                                        size="small"
                                        width={120}
                                        onClick={() => {
                                            setShowBalance(showBalance_ ? false : true);
                                        }}
                                    >
                                        {showBalance_ ? (list.length <= 1 ? 'Show UTxO' : 'Show UTxOs') : 'Show Balance'}
                                    </Button>
                                </div>
                                <svg width="45" height="45" className={styles.icon} onClick={handleClose}>
                                    <use href={CLOSE}></use>
                                </svg>
                            </header>
                            <div className={styles.rowSettings}>
                                <p className={styles.title}>Address:</p>
                                <p className={styles.value}>{formatAddress(address)}</p>
                                <CopyButton content={address} />
                                <OpenInNewTabButton url={appStore.siteSettings !== undefined ? `${appStore.siteSettings.getblockfrost_url_explorer_address(address)}` : ``} />
                            </div>
                            {showBalance_ ? (
                                <>
                                    <div className={styles.detailsTable}>
                                        {isRefreshing || isLoadingList ? <div className={styles.loadingDiv}>{<LoaderButton />}</div> : <DetailsBalance uTxOs={list} />}
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className={styles.detailsTable}>
                                        {isRefreshing || isLoadingList ? <div className={styles.loadingDiv}>{<LoaderButton />}</div> : <DetailsUTxOs uTxOs={list} />}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            ) : null}
        </>
    );
    //--------------------------------------
};
